<ion-content class="ion-text-center modal">
  <rc-modal-header></rc-modal-header>

  <ion-row class="ion-margin-top">
    <ion-col push="3" size="6">
      <ion-img class="logo" src="assets/logo/dark_logo_vertical.png"></ion-img>
    </ion-col>
  </ion-row>

  @if (itemInput) {
    <ion-row class="ion-justify-content-center">
      <ion-col>
        <h2>{{ userToString(user) }}</h2>
        <h3>{{ baseLocationToString(subscription?.baseLocation) }}</h3>
      </ion-col>
    </ion-row>
    <ion-row class="ion-justify-content-center">
      <ion-col>
        <h4 class="item-number">{{ item?.numberId }}</h4>
      </ion-col>
    </ion-row>
  }

  @if (rack) {
    <ion-row class="ion-justify-content-center">
      <ion-col>
        <h3>Location: {{ rackToString(rack) }}</h3>
      </ion-col>
    </ion-row>
  }

  @if (car) {
    <ion-row class="ion-justify-content-center">
      <ion-col>
        <h3>Car: {{ carToString(car) }}</h3>
      </ion-col>
    </ion-row>
  }

  <ion-row class="ion-justify-content-center">
    <ion-col size="5">
      @if (loading) {
        <ion-skeleton-text class="ion-text-center"></ion-skeleton-text>
      } @else {
        <ion-img alt="qr-code-printed" [src]="qrCodeDataUrl" />
      }
    </ion-col>
  </ion-row>

  <ion-row class="ion-justify-content-center">
    <ion-col>
      <h4 class="warning">Do not remove this label</h4>
    </ion-col>
  </ion-row>

  @if (printAvailable) {
    <ion-row class="ion-justify-content-center">
      <ion-col size="7">
        @if (showPrintHints) {
          <ion-note class="print-hint">{{ brotherHint }}</ion-note>
        }
        <ion-button (click)="printBrotherLabel()" class="full-width" color="secondary" [disabled]="!canPrint">
          <ion-icon name="print-outline"></ion-icon>
          Print Label
        </ion-button>
        @if (showPrintHints) {
          <ion-note class="print-hint">{{ dymoHint }}</ion-note>
        }
        <ion-button (click)="printDymoLabel()" class="full-width" color="secondary" [disabled]="!canPrint">
          <ion-icon name="print-outline"></ion-icon>
          Print Small Label
        </ion-button>
      </ion-col>
    </ion-row>
  }
</ion-content>
